import React, { type ReactNode } from 'react';
import { cssMap, styled } from '@compiled/react';
import AddIcon from '@atlaskit/icon/core/migration/add';
import { components } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import type { MenuListProps } from '@atlaskit/react-select';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export type Props = {
	children: ReactNode;
	showFooter: boolean;
	projectKey: string;
	footerLabel?: string;
};

const menuListStyles = cssMap({
	root: {
		paddingBlockStart: token('space.0'),
		paddingBlockEnd: token('space.0'),
	},
});

const MenuWithFooter = (props: Props & MenuListProps) => {
	const { formatMessage } = useIntl();
	const { children, showFooter, projectKey, footerLabel, ...restProps } = props;
	return (
		<>
			<components.MenuList {...restProps} xcss={menuListStyles.root}>
				{children}
			</components.MenuList>
			{showFooter && (
				<FooterWrapper>
					<FooterLinkWrapper>
						<FooterLink
							href={`/plugins/servlet/project-config/${projectKey}/administer-components`}
						>
							<AddIcon label="componentFooterAddIcon" LEGACY_size="small" />
							<LinkText>{footerLabel ?? formatMessage(messages.componentLabel)}</LinkText>
						</FooterLink>
					</FooterLinkWrapper>
				</FooterWrapper>
			)}
		</>
	);
};

export default MenuWithFooter;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LinkText = styled.span({
	marginLeft: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FooterWrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	paddingTop: token('space.100'),
	paddingRight: '0px',
	paddingBottom: token('space.100'),
	paddingLeft: '0px',
	borderTop: `2px solid ${token('color.border')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FooterLinkWrapper = styled.div({
	paddingTop: token('space.050'),
	paddingRight: token('space.150'),
	paddingBottom: token('space.050'),
	paddingLeft: token('space.150'),
	width: '100%',
	'&:hover': {
		backgroundColor: token('color.background.neutral.subtle.hovered'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FooterLink = styled.a({
	display: 'flex',
	alignItems: 'center',
	'&:hover': {
		textDecoration: 'none',
	},
});
